export default __webpack_public_path__ + "static/media/Stand_Full.dc99fdda.png";